import { render, staticRenderFns } from "./Internal-Refund.vue?vue&type=template&id=23bfba05&"
import script from "./Internal-Refund.vue?vue&type=script&lang=js&"
export * from "./Internal-Refund.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports